import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const sections = [
  {
    title: "Main Pages",
    links: [
      { label: "Home", href: "/" },
      { label: "About Us", href: "/about" },
      { label: "Service Offerings", href: "/service-offerings" },
      { label: "User Consent", href: "/user-consent" },
      { label: "Contact Us", href: "/contact" },
    ],
  },
  {
    title: "Investor Resources",
    links: [
      { label: "Investor Charter", href: "/investor-charter" },
      { label: "Complaint Board", href: "/complaint-board" },
      { label: "Grievance Redressal", href: "/grievance-policy" },
      { label: "Do's & Don'ts", href: "/do-dont" },
      { label: "Disclosure", href: "/disclosure" },
    ],
  },
  {
    title: "Legal & Compliance",
    links: [
      { label: "Terms & Conditions", href: "/tandc" },
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Refund Policy", href: "/refund-policy" },
      { label: "Legal Disclaimer", href: "/legal-disclaimer" },
      { label: "Ad Disclaimer", href: "/ad-disclaimer" },
      { label: "Accessibility Statement", href: "/accessibility-statement" },
    ],
  },
  {
    title: "External Links",
    links: [
      {
        label: "SEBI SCORES Complaint Portal",
        href: "https://scores.sebi.gov.in/",
        external: true,
      },
      {
        label: "SEBI ODR – Online Dispute Resolution Portal",
        href: "https://smartodr.in/intermediary/login",
        external: true,
      },
    ],
  },
];

const Sitemap = () => {
  return (
    <section className="min-h-screen py-20 px-4 bg-white text-black selection:bg-[#1e6091]/30">
      <Helmet>
        <title>Sitemap | Option Bricks</title>
        <meta
          name="description"
          content="Browse all pages available on the Option Bricks website. Find links to our services, legal information, investor resources, and more."
        />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-black mb-6 mt-20 tracking-tight">
            Sitemap
          </h1>
          <div className="h-1 w-24 bg-[#1e6091] mx-auto rounded-full mb-6" />
          <p className="text-gray-700 max-w-2xl mx-auto text-lg">
            A complete overview of all pages available on the Option Bricks
            website.
          </p>
        </div>

        {/* Sections */}
        <div className="grid gap-10 sm:grid-cols-2">
          {sections.map((section) => (
            <div
              key={section.title}
              className="bg-gray-50 border border-gray-200 rounded-2xl p-6"
            >
              <h2 className="text-lg font-bold mb-4 text-black">
                {section.title}
              </h2>
              <ul className="space-y-3">
                {section.links.map((link) =>
                  link.external ? (
                    <li key={link.href}>
                      
                      <a  href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#1e6091] underline hover:text-[#185076] text-sm transition-colors"
                      >
                        {link.label}
                        <span className="ml-1 text-xs text-gray-500">↗</span>
                      </a>
                    </li>
                  ) : (
                    <li key={link.href}>
                      <Link
                        to={link.href}
                        className="text-[#1e6091] underline hover:text-[#185076] text-sm transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sitemap;